var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.1761 30.2266L24.2441 31.1131L25.0271 32.4931",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.367 26.6851C117.964 25.1851 117.994 24.6181 117.046 23.5951C116.098 22.5721 113.792 20.1031 113.792 20.1031C113.792 20.1031 113.737 18.5776 112.4 17.9281C111.064 17.2786 109.592 16.7341 108.64 16.6591C107.689 16.5841 79.1886 15.2611 79.1886 15.2611L79.0191 13.9966L77.2746 11.0491L74.6286 12.2206L66.8016 12.7831L62.2971 13.9186L57.9951 15.4306L56.2971 16.5841L55.1031 19.0336L54.4131 20.3281L28.4526 22.0171V23.0866L27.4386 23.7616L5.30762 24.0856L1.34912 24.6346L0.620117 24.7891C0.620117 24.7891 2.22812 26.2516 3.20312 26.5426C4.17962 26.8336 6.58112 27.0406 6.58112 27.0406L21.4416 27.4786L27.7761 27.5761L28.7331 28.0411V29.0551L38.3346 29.9971L26.1756 30.2236L24.2451 31.1101L25.0281 32.4901L26.8836 33.8671L33.2676 35.9251L37.6401 34.6996C37.6401 34.6996 39.0381 33.9406 41.4441 34.1221C43.8501 34.3036 48.0381 35.1856 48.0381 35.1856L53.1606 36.6331L57.6801 38.8231C57.6801 38.8231 60.5751 40.0441 61.8351 41.2171C63.0951 42.3886 65.0781 44.4601 65.0781 44.4601L67.7736 46.5196L72.9186 48.9196C72.7986 49.7476 83.9946 50.5516 83.9946 50.5516L93.7041 49.6636L96.2181 47.1496L95.4351 45.7786L95.7591 43.8646C95.7591 43.8646 96.7176 42.5491 97.6191 42.3151C98.5191 42.0796 109.213 40.4011 109.625 40.3156C110.036 40.2301 111.713 39.9676 112.454 39.4276C113.195 38.8876 114.23 37.1206 114.23 37.1206L117.421 33.3766C117.421 33.3766 118.418 31.9981 118.541 30.4981C118.664 28.9981 118.772 28.1806 118.369 26.6806L118.367 26.6851ZM82.6236 40.7146C81.3846 40.7716 77.6676 40.7146 77.6676 40.7146C77.6676 40.7146 76.8786 40.7716 76.7661 39.5881C76.6536 38.4061 76.0911 34.0696 76.0911 34.0696L77.1606 32.5486L77.2731 29.5081C77.2731 29.5081 74.9646 27.5371 75.2466 25.5106C75.5286 23.4841 76.0911 23.4271 76.0911 23.4271L78.5691 21.7936C78.5691 21.7936 82.0611 23.3701 82.2861 23.8771C82.5111 24.3841 82.7931 25.1716 82.9611 26.1856C83.1306 27.1996 83.2431 32.6056 83.2431 32.6056C83.2431 32.6056 83.8626 34.0696 83.9751 34.4641C84.0876 34.8586 83.6376 39.3076 83.6376 39.3076C83.6376 39.3076 83.8626 40.6591 82.6236 40.7161V40.7146ZM96.1386 30.4096L92.5911 32.4931L88.5936 30.0001V25.6231L92.0286 23.7646L96.1401 26.0176V30.4096H96.1386ZM112.013 30.4096L108.466 32.4931L104.468 30.0001V25.6231L107.903 23.7646L112.015 26.0176V30.4096H112.013Z",
    fill: "#FAFAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2262 27.5805L68.2087 27.6225L70.6852 26.5245V24.4965L68.7352 23.5965L58.2682 23.6385L27.4387 23.7645",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2678 23.6386L59.6418 25.2571L57.6768 27.6121",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.001 27.6121L63.0415 23.7661C63.0415 23.7661 63.952 25.6186 64.771 26.6866C65.068 27.0736 65.3515 27.3571 65.5765 27.4126",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7705 26.685C64.7705 26.685 66.3635 25.533 67.232 24.5175C67.5215 24.1785 67.73 23.856 67.772 23.595",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2324 24.519C67.2324 24.519 67.6674 26.3505 70.1694 26.754",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6543 35.337L71.7858 34.6485L76.0908 34.0695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7857 34.6484C71.7857 34.6484 71.1077 35.8589 70.6862 36.6614C70.2632 37.4639 68.7002 38.2244 68.7002 38.2244",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3906 39.588C69.3906 39.588 71.9526 38.1375 72.8391 37.209C73.7256 36.2805 73.8456 34.371 73.8456 34.371V41.643",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5254 20.9775C83.5254 20.9775 84.9894 21.738 85.2144 23.7645C85.4394 25.791 85.5579 43.6635 85.5579 43.6635L87.5229 44.7135L95.0964 45.783",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3662 33.6615C95.7014 33.6615 98.4052 30.9577 98.4052 27.6225C98.4052 24.2872 95.7014 21.5835 92.3662 21.5835C89.0309 21.5835 86.3271 24.2872 86.3271 27.6225C86.3271 30.9577 89.0309 33.6615 92.3662 33.6615Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.965 35.0445C111.532 35.0445 114.424 32.1527 114.424 28.5855C114.424 25.0183 111.532 22.1265 107.965 22.1265C104.397 22.1265 101.506 25.0183 101.506 28.5855C101.506 32.1527 104.397 35.0445 107.965 35.0445Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4951 20.6685C56.4951 20.6685 65.1561 18.3315 66.6546 18.078C68.1516 17.8245 73.3896 17.571 74.5716 17.1495C75.7536 16.728 76.5141 15.798 76.5141 15.798L78.6816 15.2625",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30762 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75684 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.207 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1057 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5547 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0046 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4541 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9033 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3535 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8025 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2539 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7031 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1523 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6025 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0515 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5012 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9502 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4004 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8496 24.9615V25.848",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2988 24.9616V25.8481",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5029 31.6769V32.3204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4451 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3877 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3301 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2725 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2168 31.6769V32.3204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1592 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1016 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0442 31.677V32.3205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9863 31.6769V32.3204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7595 29.586V30",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4902 29.5859V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2227 29.5859V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9541 29.586V30",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6855 29.5859V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.418 29.5859V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1484 29.5859V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4902 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2227 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9541 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6855 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.418 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1484 31.2675V31.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0827 38.829C63.767 38.829 64.3217 38.2743 64.3217 37.59C64.3217 36.9057 63.767 36.351 63.0827 36.351C62.3985 36.351 61.8438 36.9057 61.8438 37.59C61.8438 38.2743 62.3985 38.829 63.0827 38.829Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0079 43.3589C96.0079 43.3589 95.9704 40.4909 97.8844 39.2519C99.7984 38.0129 102.164 37.7879 103.121 37.2809",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M101.506 41.2215C101.506 41.2215 101.479 38.8485 104.468 38.007C107.458 37.167 111.568 35.928 111.568 35.928",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M107.965 40.3184C107.965 40.3184 107.908 38.8469 110.048 38.0069C112.189 37.1669 114.892 34.6469 114.892 34.6469",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9255 15.996C92.9255 15.996 93.2105 16.839 95.096 17.4585C96.983 18.078 100.024 18.4155 100.981 19.035",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.719 16.3395C101.719 16.3395 101.432 17.571 103.853 18.3585C106.274 19.1475 107.165 18.933 108.24 19.518",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M107.689 16.5855C107.689 16.5855 108.472 17.289 110.33 18.36C112.189 19.431 112.921 20.6685 112.921 20.6685",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.21 12.258C73.21 12.258 75.247 12.7275 75.5845 14.0235C75.922 15.318 75.223 16.5855 75.223 16.5855",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1887 18.3585L81.9112 15.4305",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3428 18.3585L84.4263 15.996",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3271 18.483L88.5936 15.996",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6855 47.7841C70.6855 47.7841 72.052 47.1346 75.6775 46.7116C79.3015 46.2886 84.9895 46.7116 84.9895 46.7116",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0.620117 24.7921C0.620117 24.7921 2.22512 26.6596 4.75862 26.9296C7.29212 27.1996 25.8621 27.5806 25.8621 27.5806H28.2276L28.7346 28.0456V29.0596L43.2636 30.0016L58.5801 29.5666C58.5801 29.5666 64.3806 31.7626 66.3516 34.8601C68.3226 37.9576 69.3921 39.5896 69.3921 39.5896L74.5161 42.3496L84.8781 43.8706C84.8781 43.8706 89.1576 42.7441 89.8896 40.9426C90.6216 39.1411 91.5231 35.8741 91.5231 35.8741C91.5231 35.8741 91.4661 35.5366 92.6496 35.4241C93.8331 35.3116 108.643 35.1421 108.643 35.1421L111.853 34.3321L114.049 31.9876L114.556 30.0016L117.089 28.9471L118.666 29.0041V27.9901L117.089 27.8206L114.724 26.4691C114.724 26.4691 114.161 24.2731 113.035 23.3161C111.908 22.3591 110.332 21.4021 107.629 21.2896C104.926 21.1771 95.0151 21.2896 95.0151 21.2896L93.1011 18.5866L78.0096 18.3616L74.9691 20.6701C74.9691 20.6701 68.9436 21.2326 67.4226 21.4021C65.9016 21.5716 62.7486 22.3591 62.7486 22.3591L57.3996 21.9091C57.3996 21.9091 56.6676 20.7271 55.5981 20.6146C54.5286 20.5021 28.4556 22.0231 28.4556 22.0231V23.0926L27.7806 23.5996L6.49412 24.0496C6.49412 24.0496 3.79112 24.1066 2.77712 24.3316C1.76312 24.5566 0.623117 24.7966 0.623117 24.7966L0.620117 24.7921Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.569 21.7936C78.569 21.7936 82.061 23.3701 82.286 23.8771C82.511 24.3841 82.793 25.1716 82.961 26.1856C83.129 27.1996 83.243 32.6056 83.243 32.6056C83.243 32.6056 83.8625 34.0696 83.975 34.4641C84.0875 34.8586 83.6375 39.3076 83.6375 39.3076C83.6375 39.3076 83.8625 40.6591 82.6235 40.7161C81.3845 40.7731 77.6675 40.7161 77.6675 40.7161C77.6675 40.7161 76.8785 40.7731 76.766 39.5896C76.6535 38.4061 76.091 34.0711 76.091 34.0711L77.1605 32.5501L77.273 29.5096C77.273 29.5096 74.9645 27.5386 75.2465 25.5121C75.5285 23.4856 76.091 23.4286 76.091 23.4286L78.569 21.7951V21.7936Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0288 23.7646L96.1387 26.0176V30.4096L92.5913 32.4931L88.5938 30.0001V25.6231L92.0288 23.7646Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.903 23.7647L112.014 26.0177V30.4097L108.465 32.4932L104.468 30.0002V25.6232L107.903 23.7647Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4121 20.3296C54.4121 20.3296 54.7496 17.7391 56.8331 16.1056C58.9166 14.4721 66.8006 12.7831 66.8006 12.7831C66.8006 12.7831 73.4456 12.2206 73.7831 12.2206H74.6276L77.2736 11.0491L79.3001 14.4736L78.6806 15.2626C78.6806 15.2626 95.2646 16.1356 97.7141 16.2196C100.164 16.3036 107.794 16.4731 109.146 16.7266C110.497 16.9801 112.722 17.7691 113.2 18.6976C113.679 19.6261 113.791 20.1061 113.791 20.1061C113.791 20.1061 117.057 23.5981 117.508 24.1036C117.958 24.6106 118.663 27.9886 118.663 27.9886",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M118.664 29.0026C118.664 29.0026 118.748 31.1281 117.692 32.9446C116.636 34.7611 114.229 37.1251 114.229 37.1251L113.468 38.6026C113.468 38.6026 112.835 39.4471 111.356 39.9121C109.877 40.3771 103.67 41.3896 102.445 41.5171C101.219 41.6431 98.0945 42.1501 98.0945 42.1501C98.0945 42.1501 96.5885 42.6151 96.137 43.1641C95.687 43.7131 95.0945 45.7831 95.0945 45.7831L96.6995 46.6696L93.701 49.6681C93.701 49.6681 86.4365 50.5126 85.169 50.5546C83.9015 50.5966 73.217 49.0771 73.217 49.0771C73.217 49.0771 66.9665 45.9511 65.615 44.9386C64.2635 43.9261 62.405 40.9681 58.7735 39.1951C55.142 37.4206 53.7905 36.7456 51.593 36.1546C49.397 35.5636 44.378 34.0426 41.4395 34.1281C38.501 34.2136 33.9395 35.7331 33.9395 35.7331L30.2225 34.9726C30.2225 34.9726 26.5475 33.9586 25.745 33.2836C24.9425 32.6086 24.4775 31.5946 24.4775 31.5946C24.4775 31.5946 23.8865 30.8341 24.4775 30.4966C25.0685 30.1591 28.067 30.1591 29.3345 30.2011C30.602 30.2431 43.2575 30.0031 43.2575 30.0031",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1732 43.0516C87.1732 43.0516 85.6371 39.1111 87.5796 36.6616C89.5222 34.2121 92.7322 34.1281 92.7322 34.1281C92.7322 34.1281 95.0976 33.5656 96.6171 32.4946C98.1366 31.4236 98.9752 27.6241 98.9752 27.6241H101.264C101.264 27.6241 100.729 34.7191 108.641 35.1421",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9658 20.6685L95.0118 21.288",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbine);
export default __webpack_public_path__ + "static/media/Carbine.6ad0c9f580ecbb2ebe9970ead11ba191.svg";
export { ForwardRef as ReactComponent };